import { Box } from "@mui/system";
import React from "react";
import { Typewriter } from "react-simple-typewriter";
// import Particles from "react-particles-js";
import Particles from "react-tsparticles";
import profile from "../../../images/Photo for CV.jpg";
import "./Banner.css";

const Banner = () => {
  return (
    <div
      style={{
        background:
          "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Particles
        id="tsparticles"
        options={{
          background: {
            color: {
              value:
                "linear-gradient(45deg, rgb(45, 54, 76) 0%, rgb(37, 45, 63) 100%)",
            },
          },
          fpsLimit: 60,
          interactivity: {
            events: {
              onClick: {
                enable: false,
                mode: "push",
              },
              onHover: {
                enable: false,
                mode: "repulse",
              },
              resize: true,
            },
            modes: {
              bubble: {
                distance: 400,
                duration: 2,
                opacity: 0.8,
                size: 40,
              },
              push: {
                quantity: 4,
              },
              repulse: {
                distance: 200,
                duration: 0.4,
              },
            },
          },
          particles: {
            color: {
              value: "#ffffff",
            },
            links: {
              color: "#ffffff",
              distance: 150,
              enable: true,
              opacity: 0.5,
              width: 1,
            },
            collisions: {
              enable: false,
            },
            move: {
              direction: "none",
              enable: true,
              outMode: "bounce",
              random: false,
              speed: 6,
              straight: false,
            },
            number: {
              density: {
                enable: true,
                value_area: 800,
              },
              value: 80,
            },
            opacity: {
              value: 0.5,
            },
            shape: {
              type: "circle",
            },
            size: {
              random: true,
              value: 5,
            },
          },
          detectRetina: true,
        }}
      />
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          zIndex: 1,
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <div className="container">
            <div className="intro">
              <img className="shadow-dark" src={profile} alt="profile" />
              <h1>Md. Rabbi Hasan</h1>
              <p>
                <p
                  style={{
                    margin: "auto 0",
                    fontWeight: "normal",
                    color: "whitesmoke",
                  }}
                >
                  I'm{" "}
                  <span style={{ color: "white", fontWeight: "bold" }}>
                    {/* Style will be inherited from the parent element */}
                    <Typewriter
                      words={[
                        "Web App Developer",
                        "MERN Stack Developer",
                        "Graphics Designer",
                        "Freelancer",
                      ]}
                      loop={0}
                      cursor
                      cursorStyle="|"
                      typeSpeed={70}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </span>
                </p>
              </p>
              <div className="social-link">
                <a
                  href="https://www.facebook.com/rabbi4249/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-facebook-f"></i>
                </a>

                <a
                  href="https://github.com/Rabbi01521"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i class="fab fa-github"></i>
                </a>
                <a
                  href="https://www.linkedin.com/in/md-rabbi-hasan-206378147/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </div>
              <div className="heading-button">
                <a
                  href="https://drive.google.com/file/d/1AVwgpTnttixdYld7auT8iac4pUN46_GB/view?usp=sharing"
                  className="button button--red button--play"
                  target="_blank"
                  rel="noreferrer"
                >
                  Download Resume
                </a>
              </div>
            </div>
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default Banner;
